import { message, Modal } from 'antd';
import uuid from 'react-uuid';

/**
 * Get data from localStorage, or return defaultValue if not found.
 */
export function getLocalStorageData(key, defaultValue) {
   try {
      const data = JSON.parse(localStorage.getItem(key));
      return data !== null ? data : defaultValue;
   } catch {
      return defaultValue;
   }
}

/**
 * Set data to localStorage.
 */
export function setLocalStorageData(key, value) {
   localStorage.setItem(key, JSON.stringify(value));
}

/**
 * Remove multiple keys from localStorage.
 */
export function removeLocalStorageKeys(keys) {
   keys.forEach(key => localStorage.removeItem(key));
}

/**
 * Create assessment payload for create or update.
 * @param {Object} params - { assinfo, userId, answerSheetData, type, fileUrl }
 * @returns {Object}
 */
export function createAssessmentPayload({ assinfo, userId, answerSheetData, type = 'manual', fileUrl = '' }) {
   const isLocalhost = /localhost|[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}|::1|\.local|^$/i.test(
      window.location.hostname
   );
   const o2oMode = isLocalhost ? 'offline' : 'online';
   return {
      Id: assinfo.Id || `ass_${o2oMode}_${uuid()}`,
      Title: assinfo.title,
      Term: assinfo.term,
      File_url: fileUrl,
      Question_type: type === 'pdf' ? '1' : '2',
      Created_by: userId,
      Copied_from: null,
      Question_sheet: JSON.stringify(answerSheetData),
      Level: assinfo.level,
      Subject: assinfo.subject,
      Instruction: assinfo.instruction || '',
      ...(assinfo.Type ? { Type: assinfo.Type } : {})
   };
}

/**
 * Validate required fields for assessment.
 * @param {Object} params - { assinfo, answerSheetData, requireFileUrl }
 * @returns {Array} - Array of missing field names
 */
export function validateAssessmentFields({ assinfo, answerSheetData, requireFileUrl = false }) {
   const requiredFields = ['title', 'level', 'subject', 'term'];
   if (requireFileUrl) requiredFields.unshift('file_url');
   const missing = requiredFields.filter(field => !assinfo[field] || assinfo[field] === '');
   if (!answerSheetData || answerSheetData.length === 0) missing.push('answerSheetData');
   return missing;
}

/**
 * Show a modal listing missing fields.
 */
export function showValidationModal(missingFields) {
   Modal.info({
      title: 'Incomplete Assessment',
      content: (
         <>
            Please complete the following before saving:
            <ul>
               {missingFields.includes('file_url') && <li>Upload questionaire</li>}
               {missingFields.includes('title') && <li>Title</li>}
               {missingFields.includes('level') && <li>Grade Level</li>}
               {missingFields.includes('subject') && <li>Subject</li>}
               {missingFields.includes('term') && <li>Term</li>}
               {missingFields.includes('answerSheetData') && <li>Answer Keys</li>}
            </ul>
         </>
      ),
      centered: true,
   });
}

/**
 * Toggle assignment and assessment tool/sheet views.
 */
export function toggleAssignmentViews(setShowAssignment, setShowAssessmentToolsOrSheet) {
   setShowAssignment(prev => !prev);
   setShowAssessmentToolsOrSheet(prev => !prev);
}

export function CardRequestHelper(method, type, data, idx, sheet_data, template = null, has_answers = false) {
   var asd = [...sheet_data];
   let tmp_data;

   switch (method) {
      case "replace":
         asd[idx].template = template;
         break;
      case "remove":
         if (!has_answers) {
            asd.splice(idx, 1);
         } else {
            message.info("Removing of question is not allowed.");
         }
         break;
      case "update":
         // if (asd[idx].type !== "short_answer" && asd[idx].type !== "section" && asd[idx].type !== "long_answer") {
         if (asd[idx].type !== "section" && asd[idx].type !== "long_answer") {
            asd[idx].correct = []; asd[idx].correct.push.apply(asd[idx].correct, data.correct);
            asd[idx].option_labels = []; asd[idx].option_labels.push.apply(asd[idx].option_labels, data.option_labels);

            if (asd[idx].type.includes("image")) {
               asd[idx].image_url = []; asd[idx].image_url.push.apply(asd[idx].image_url, data.image_url);
            }
         } else {
            if (asd[idx].type !== "long_answer") {
               asd[idx].correct = []; asd[idx].correct.push(data.correct[0]);
            }
         }

         asd[idx].points = data.points;
         asd[idx].question = data.question;
         asd[idx].question_image = data.question_image;
         asd[idx].question_audio = data.question_audio;
         asd[idx].question_video = data.question_video;
         break;

      case "add":
         if (!has_answers) {
            switch (type) {
               case "section":
                  tmp_data = {
                     id: uuid(), //tmpID === undefined ? (asd.length + 1).toString() : tmpID.toString(),
                     type: "section",
                     correct: [""],
                  };

                  asd.push(tmp_data);
                  message.info("Added new section");

                  break;
               case "multiple_answer":
                  tmp_data = {
                     id: uuid(), //tmpID === undefined ? (asd.length + 1).toString() : tmpID.toString(),
                     type: "multiple_answer",
                     correct: ["0"],
                     points: "1",
                     option_labels: ["A"],
                     question: "",
                     question_image: "",
                     template,
                  };

                  asd.push(tmp_data);
                  message.info("Added multiple answer");

                  break;
               case "multiple_answer_image":
                  tmp_data = {
                     id: uuid(), //tmpID === undefined ? (asd.length + 1).toString() : tmpID.toString(),
                     type: "multiple_answer_image",
                     correct: ["0"],
                     points: "1",
                     option_labels: ["A"],
                     image_url: [""],
                     question: "",
                     question_image: "",
                     template,
                  };

                  asd.push(tmp_data);
                  message.info("Added multiple answer image");

                  break;
               case "multiple_choice":
                  tmp_data = {
                     id: uuid(), //tmpID === undefined ? (asd.length + 1).toString() : tmpID.toString(),
                     type: "multiple_choice",
                     correct: ["0"],
                     points: "1",
                     option_labels: ["A"],
                     question: "",
                     question_image: "",
                     template,
                  };

                  asd.push(tmp_data);
                  message.info("Added multiple choice");

                  break;

               case "multiple_choice_image":
                  tmp_data = {
                     id: uuid(), //tmpID === undefined ? (asd.length + 1).toString() : tmpID.toString(),
                     type: "multiple_choice_image",
                     correct: ["0"],
                     points: "1",
                     option_labels: ["A"],
                     image_url: [""],
                     question: "",
                     question_image: "",
                     template,
                  };

                  asd.push(tmp_data);
                  message.info("Added multiple choice");

                  break;

               case "short_answer":
                  tmp_data = {
                     id: uuid(), //tmpID === undefined ? (asd.length + 1).toString() : tmpID.toString(),
                     type: "short_answer",
                     correct: [""],
                     points: "1",
                     question: "",
                     question_image: "",
                     template,
                  };

                  asd.push(tmp_data);
                  message.info("Added short answer");

                  break;
               case "long_answer":
                  tmp_data = {
                     id: uuid(), //tmpID === undefined ? (asd.length + 1).toString() : tmpID.toString(),
                     type: "long_answer",
                     points: "1",
                     question: "",
                     question_image: "",
                     template,
                  };

                  asd.push(tmp_data);
                  message.info("Added essay/open-ended");

                  break;

               case "matching_type":
                  tmp_data = {
                     id: uuid(), //tmpID === undefined ? (asd.length + 1).toString() : tmpID.toString(),
                     type: "matching_type",
                     correct: [""],
                     points: "1",
                     option_labels: [["", ""]],
                     question: "",
                     question_image: "",
                     template,
                  };

                  asd.push(tmp_data);
                  message.info("Added matching type");

                  break;

               case "matching_type_image":
                  tmp_data = {
                     id: uuid(), //tmpID === undefined ? (asd.length + 1).toString() : tmpID.toString(),
                     type: "matching_type_image",
                     correct: [""],
                     points: "1",
                     option_labels: [""],
                     image_url: [["", ""]],
                     question: "",
                     question_image: "",
                     template,
                  };

                  asd.push(tmp_data);
                  message.info("Added matching type");

                  break;

               case "true_or_false":
                  tmp_data = {
                     id: uuid(), //tmpID === undefined ? (asd.length + 1).toString() : tmpID.toString(),
                     type: "true_or_false",
                     correct: ["0", "0"],
                     points: "1",
                     option_labels: ["True", "False"],
                     question: "",
                     question_image: "",
                     template,
                  };

                  asd.push(tmp_data);
                  message.info("Added true or false");

                  break;

               default:
                  break;
            }
         } else {
            message.info("Adding new question is not allowed.");
         }

         break;

      case "duplicate":
         if (!has_answers) {
            switch (asd[idx].type) {
               case "multiple_answer":
                  tmp_data = {
                     id: uuid(), //(asd.length + 1).toString(),
                     type: "multiple_answer",
                     correct: asd[idx].correct,
                     points: asd[idx].points,
                     option_labels: asd[idx].option_labels,
                     question: asd[idx].question,
                     question_image: asd[idx].question_image,
                     template: asd[idx].template,
                  };

                  asd.push(tmp_data);
                  break;

               case "multiple_answer_image":
                  tmp_data = {
                     id: uuid(), //(asd.length + 1).toString(),
                     type: "multiple_answer_image",
                     correct: asd[idx].correct,
                     points: asd[idx].points,
                     option_labels: asd[idx].option_labels,
                     image_url: asd[idx].image_url,
                     question: asd[idx].question,
                     question_image: asd[idx].question_image,
                     template: asd[idx].template,
                  };

                  asd.push(tmp_data);
                  break;

               case "multiple_choice":
                  tmp_data = {
                     id: uuid(), //(asd.length + 1).toString(),
                     type: "multiple_choice",
                     correct: asd[idx].correct,
                     points: asd[idx].points,
                     option_labels: asd[idx].option_labels,
                     question: asd[idx].question,
                     question_image: asd[idx].question_image,
                     template: asd[idx].template,
                  };

                  asd.push(tmp_data);
                  break;

               case "multiple_choice_image":
                  tmp_data = {
                     id: uuid(), //(asd.length + 1).toString(),
                     type: "multiple_choice_image",
                     correct: asd[idx].correct,
                     points: asd[idx].points,
                     option_labels: asd[idx].option_labels,
                     image_url: "",
                     question: asd[idx].question,
                     question_image: asd[idx].question_image,
                     template: asd[idx].template,
                  };

                  asd.push(tmp_data);
                  break;

               case "short_answer":
                  tmp_data = {
                     id: uuid(), //(asd.length + 1).toString(),
                     type: "short_answer",
                     correct: asd[idx].correct,
                     points: asd[idx].points,
                     question: asd[idx].question,
                     question_image: asd[idx].question_image,
                     template: asd[idx].template,
                  };

                  asd.push(tmp_data);
                  break;

               case "long_answer":
                  tmp_data = {
                     id: uuid(), //(asd.length + 1).toString(),
                     type: "long_answer",
                     points: asd[idx].points,
                     question: asd[idx].question,
                     question_image: asd[idx].question_image,
                     template: asd[idx].template,
                  };

                  asd.push(tmp_data);
                  break;

               case "matching_type":
                  tmp_data = {
                     id: uuid(), //tmpID === undefined ? (asd.length + 1).toString() : tmpID.toString(),
                     type: "matching_type",
                     correct: asd[idx].correct,
                     points: asd[idx].points,
                     option_labels: asd[idx].option_labels,
                     question: asd[idx].question,
                     question_image: asd[idx].question_image,
                     template: asd[idx].template,
                  };

                  asd.push(tmp_data);
                  message.info("Added matching type");

                  break;

               case "matching_type_image":
                  tmp_data = {
                     id: uuid(), //tmpID === undefined ? (asd.length + 1).toString() : tmpID.toString(),
                     type: "matching_type_image",
                     correct: asd[idx].correct,
                     points: asd[idx].points,
                     image_url: ['', ''],
                     option_labels: asd[idx].option_labels,
                     question: asd[idx].question,
                     question_image: asd[idx].question_image,
                     template: asd[idx].template,
                  };

                  asd.push(tmp_data);
                  message.info("Added matching type");

                  break;

               case "true_or_false":
                  tmp_data = {
                     id: uuid(), //(asd.length + 1).toString(),
                     type: "true_or_false",
                     correct: asd[idx].correct,
                     points: asd[idx].points,
                     option_labels: asd[idx].option_labels,
                     question: asd[idx].question,
                     question_image: asd[idx].question_image,
                     template: asd[idx].template,
                  };

                  asd.push(tmp_data);
                  break;
               default:
                  break;
            }

            message.info('Copy successful');
         } else {
            message.info("Adding new question is not allowed.");
         }

         break;
      default:
         break;
   }

   return asd;
}

function isIDExist(data, id) {
   for (var i = 0; i < data.length; i++) {
      if (data[i].id === id.toString()) {
         return true;
      }
   }

   return false;
}
